import { IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import clsx from 'clsx'

const CustomModalHeader = ({
  heading,
  subHeading,
  icon,
  handleClose,
  className
}) => (
  <header
    className={clsx(
      'flex items-center justify-between gap-2 py-4 2xl:py-5 px-6 select-none rounded-t-2xl 2xl:rounded-t-3xl dark:text-dark-light',
      className
    )}
    // style={{ borderBottom: '1px solid #ddd' }}
  >
    <div className="flex flex-1 space-x-2 items-center">
      {icon && <span>{icon}</span>}
      <div className="w-full">
        <h2 className="text-lg 2xl:text-xl font-semibold text-primary-dark dark:text-dark-light">
          {heading}
        </h2>
        {subHeading && (
          <p className="text-xs text-custom-gray-dark-3 dark:text-dark-light">
            {subHeading}
          </p>
        )}
      </div>
    </div>
    {handleClose && (
      <IconButton onClick={handleClose} size="small">
        <CloseIcon size="small" fontSize="small" />
      </IconButton>
    )}
  </header>
)

export default CustomModalHeader
